import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { v4 as uuidv4 } from "uuid";
import DisplayFileProper from "../../../Common/FilesRelevent/DisplayFileProper";
import DownloadButton from "../../../Common/FilesRelevent/DownloadButton";
import {
  validDocumentTypes,
  validImageTypes,
  isAllowedFile,
} from "../../../../assests/extention/fileextention";
import AsteriskLabel from "../../../Common/AsteriskLabel";

export default function BXPImages({ formik, name, values, topindex }) {
  const [selectedFiles, setSelectedFiles] = useState([]);
  
  // 1. ADDED: State to manage loading status
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => {
    setSelectedFiles(values);
  }, [values]); // Added `values` to dependency array to stay in sync

  const handleUpload = (files) => {
    // 2. ADDED: Set uploading to true before starting uploads
    setIsUploading(true);

    const uploadPromises = files.map((file) => {
      if (file.size > 10 * 1024 * 1024) {
        urtoast(`File size exceeds 10MB limit.`);
        return Promise.reject(new Error("File size exceeds limit."));
      }

      if (!isAllowedFile(file)) {
        urtoast("Unsupported file format. Please upload a valid file type.", 2);
        return Promise.reject(new Error("Unsupported file type."));
      }

      if (
        validImageTypes.includes(file.type) ||
        validDocumentTypes.includes(file.type)
      ) {
        const uniqueId1 = uuidv4();
        const storageRef = ref(
          getStorage(),
          `/Category/${uniqueId1}_${file.name}`
        );
        const uploadTask = uploadBytesResumable(storageRef, file);
        
        return uploadTask
          .then(async () => {
            const url = await getDownloadURL(uploadTask.snapshot.ref);
            return { file: url, status: 1 }; // status 1 for uploaded
          })
          .catch((error) => {
            urtoast(`Error uploading ${file.name}: ${error.message}`);
            throw error;
          });
      } else {
        urtoast(`This file type is not supported`);
        return Promise.reject(new Error("Unsupported file type."));
      }
    });

    Promise.all(uploadPromises)
      .then((urls) => {
        const updatedFiles = [...selectedFiles, ...urls];
        setSelectedFiles(updatedFiles);
        formik.setFieldValue(name, updatedFiles);
      })
      .catch((error) => {
        console.error("Error uploading files: ", error);
      })
      .finally(() => {
        // 3. ADDED: Turn off the loader regardless of success or failure
        setIsUploading(false);
      });
  };

  const onDrop = (acceptedFiles) => {
    handleUpload(acceptedFiles);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const handleDeleteImage = (index) => {
    // Update status to 3 to mark as deleted
    const updatedFiles = selectedFiles.map((item, idx) => {
      if (idx === index && item.status !== 3) {
        return { ...item, status: 3 };
      }
      return item;
    });

    setSelectedFiles(updatedFiles);
    formik.setFieldValue(name, updatedFiles);
  };

  return (
    <div className="add-portfolio">
      <h6 className="skill-right file-attachment">
        Upload file <AsteriskLabel /> <span> (Upload at least 1 file)</span>
      </h6>
      <div className="col-md-5 p-0">
        {selectedFiles.length === 0 ? (
          <div className="image-container">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/file-upload.png`}
              className="cover-img w-100"
              alt="Certificate"
            />
          </div>
        ) : (
          selectedFiles
            .filter((item) => item.status !== 3) // Filter out deleted files
            .map((item, index) => (
              <div key={index} className="image-container">
                <DisplayFileProper item={item} />
                <DownloadButton file={item} />
                <button
                  type="button"
                  className="delete-button"
                  onClick={() => handleDeleteImage(index)}
                >
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/delete-icon.svg`}
                    alt="Delete"
                  />
                </button>
              </div>
            ))
        )}
      </div>
      
      {formik?.errors?.work_sample &&
      Array.isArray(formik.errors.work_sample) &&
      formik.errors.work_sample[topindex]?.files ? (
        <p style={{ color: "red" }}>
          {formik.errors.work_sample[topindex].files}
        </p>
      ) : null}

      {/* 4. ADDED: Loading UI block */}
      {isUploading && (
        <div style={{ padding: "10px", color: "#007bff", fontWeight: "500", display: "flex", alignItems: "center", gap: "8px" }}>
           <span>Uploading files, please wait...</span>
        </div>
      )}

      {/* Disabled dropzone while uploading to prevent duplicate uploads */}
      <div
        {...getRootProps({
          className: `dropzone borderstylex ${isUploading ? 'disabled' : ''}`,
          style: { pointerEvents: isUploading ? "none" : "auto", opacity: isUploading ? 0.6 : 1 }
        })}
      >
        <input {...getInputProps()} disabled={isUploading} />
        {isDragActive ? (
          <p>Drop the files here...</p>
        ) : (
          <p>
            Drag and drop or <span>Browse file</span>
          </p>
        )}
      </div>
      
      <ul className="border-ul">
        <li>Images (JPG, PNG, JPEG up to 10MB)</li>
        <li>Documents (PDF, DOCX, XLSX, PPTX, ZIP upto 10MB)</li>
      </ul>
    </div>
  );
}